import { useState, useEffect } from 'react';

type ToastProps = {
  content: string;
  onClose: Function;
  onAfterClose?: Function;
};

export default function Toast({ content, onClose, onAfterClose }: ToastProps) {
  const [animation, setAnimation] = useState('animate-slideUp');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimation('animate-slideDown');
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (animation === 'animate-slideDown') {
      const timeout = setTimeout(() => {
        onAfterClose && onAfterClose();
        onClose();
      }, 200);

      return () => clearTimeout(timeout);
    }
  }, [animation, onAfterClose, onClose]);

  return (
    <div
      className={`flex flex-col fixed ${animation} surface_secondary_inverse
      max-w-[328px] py-[16px] px-[20px] box-border top-[50%] left-[50%] z-50 translate-x-[-50%] translate-y-[-50%] rounded-[8px] shadow-s`}
    >
      <div className="font_label_bold_lg content_primary_inverse text-left">
        {content}
      </div>
    </div>
  );
}

Toast.displayName = 'Toast';
